import {BaseSearchTabConfigModel} from "../../../models/base-search-tab-config.model";

export class SearchTabFilterModel {
    public tab: BaseSearchTabConfigModel;
    public isSelected: boolean;
}
